import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { getSitesSitesGet } from "@/client/sdk.gen";
import type { SiteResponse } from "@/client/types.gen";
import ShopCard from "./ShopCard";
import "./Landing.css";
import loadingPage from "../Status/Loading";

export default function Landing() {
  const { user } = useAuth();

  const myShops = [
    { id: 1, name: "SHOP NAME", location: "Location, Address", isNew: true },
  ];

  const [allShops, setAllShops] = useState<SiteResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSitesSitesGet().then(response => {
      setAllShops(response.data ?? []);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return loadingPage();
  }

  return (
    <main className="landing">
      {/* TODO: get user collection from /collections/me and only render this content if exists */}
      {/* <h2 className="collection-title">Collection {user.display_name}</h2>
      
      <div className="card-row">
        {myShops.map((shop: any) => (
          <ShopCard 
            key={shop.id} 
            name={shop.name}
            location={shop.location}
            isNew={shop.isNew}
          />
        ))}
        
        {/ * fill remaining slots with empty cards * /}
        {Array.from({ length: 5 - myShops.length }).map((_, i) => (
          <ShopCard key={`empty-${i}`} />
        ))}
      </div>
      
      <div className="divider">
        <span>All Shops</span>
      </div> */}
      
      <div className="filter-section">
        <h1>Shops</h1>
        {/* <button className="filter-button">Filter</button> */}
        
        <div className="shop-grid">
          {allShops.map((shop) => (
            <ShopCard 
              key={shop.id}
              {...shop}
            />
          ))}
        </div>
      </div>
    </main>
  );
}
